/* ck-app.js — global interactions (no framework).
 * Mobile nav, accordion, advisor tags, compare cols, collection sort, cart badge.
 * Document-level delegation so Theme Editor re-renders need no rebind.
 */
(function () {
  'use strict';
  if (window.__ckAppBound) return;
  window.__ckAppBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-main-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var tag = e.target.closest('[data-tag-group] [data-tag]');
    if (tag) {
      tag.classList.toggle('is-on');
      tag.setAttribute('aria-pressed', tag.classList.contains('is-on') ? 'true' : 'false');
      return;
    }

    var colBtn = e.target.closest('[data-compare-cols] [data-col]');
    if (colBtn) {
      var picker = colBtn.closest('[data-compare-cols]');
      var table = document.querySelector(picker.getAttribute('data-target'));
      if (!table) return;
      var col = colBtn.getAttribute('data-col');
      colBtn.classList.toggle('is-on');
      var on = colBtn.classList.contains('is-on');
      table.querySelectorAll('[data-col="' + col + '"]').forEach(function (cell) {
        cell.style.display = on ? '' : 'none';
      });
    }
  });

  /* Collection sort: submit GET form. JS-off uses section <noscript> Apply. */
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var sort = e.target.closest('[data-ck-sort]');
    if (sort && sort.form) sort.form.submit();
  });

  /* Header badge: drawer emits full cart; ignore partial add.js payloads. */
  document.addEventListener('ck:cart-updated', function (e) {
    var cart = e && e.detail;
    if (!cart || typeof cart.item_count !== 'number') return;
    var badge = document.querySelector('[data-cart-count]');
    if (badge) badge.textContent = cart.item_count;
  });

  /* Exclusive accordion. 'toggle' does not bubble — capture phase. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    if (!d.parentNode || !d.parentNode.matches || !d.parentNode.matches('[data-accordion]')) return;
    d.parentNode.querySelectorAll('details').forEach(function (other) {
      if (other !== d) other.open = false;
    });
  }, true);
})();
